import { PartialTranslation } from '../translations';

export const bg: PartialTranslation = {
  newChat: 'Нов чат',
  search: 'Търсене',
  user: 'Потребител',
  settings: 'Настройки',
  language: 'Език',
  getHelp: 'Получи помощ',
  viewAllPlans: 'Виж всички планове',
  learnMore: 'Научи повече',
  logOut: 'Излез',
  chooseLanguage: 'Избери език',
  chooseYourPreferredLanguage: 'Избери предпочитания език',
  searchLanguages: 'Търси езици...',
  autoDetect: 'Автоматично разпознаване',
  noLanguagesFound: 'Няма намерени езици',
  askAnything: 'Попитай каквото искаш',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Личен',
  freePlan: 'Безплатен план',
  current: 'Текущ',
  close: 'Затвори',
  archive: 'Архив',
  delete: 'Изтрий',
  confirmDelete: 'Сигурен ли си, че искаш да изтриеш този чат?',
  confirmArchive: 'Сигурен ли си, че искаш да архивираш този чат?',
  deleteCannotUndo: 'Това действие не може да бъде отменено.',
  archiveCanFind: 'Можеш да го намериш в списъка с архиви след архивиране.',
  
  // 资源面板
  resources: 'Ресурси',
  addResource: 'Добави ресурс',
  deleteResource: 'Изтрий ресурс',
  noMatchingResourcesFound: 'Няма намерени съответстващи ресурси',
  noResourcesAvailable: 'Няма налични ресурси',
  hideResources: 'Скрий ресурси',
  showResources: 'Покажи ресурси',
  
  // 聊天输入框
  typeMessage: 'Въведи съобщение...',
  thinkingOptions: 'Опции за мислене',
  deleteFile: 'Изтрий файл',
  clearSelection: 'Изчисти избора',
  addAttachment: 'Добави прикачен файл',
  sendMessage: 'Изпрати съобщение',
  
  // 思考模式选项
  deepInsight: 'Дълбока проницателност · Повърхностен анализ',
  deepInsightDesc: 'Бързо разбиране на ключовите точки',
  deepExploration: 'Дълбоко изследване · Цялостен анализ',
  deepExplorationDesc: 'Многоизмерно задълбочено изследване',
  deepDeconstruction: 'Дълбока деконструкция · Систематичен аргумент',
  deepDeconstructionDesc: 'Слой по слой прогресивен анализ',
  
  // 写作模式选项
  contractReview: 'Преглед на договор · Идентификация на риска',
  contractReviewDesc: 'Анализ на клаузи и проверка на съответствието',
  textPolish: 'Полиране на текст · Професионално изразяване',
  textPolishDesc: 'Езикова оптимизация и структурно настройване',
  legalDocuments: 'Правни документи · Стандартно изготвяне',
  legalDocumentsDesc: 'Професионално писане на правни документи',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Вход',
  register: 'Регистрация',
  welcomeBack: 'Добре дошли в LawHelper',
  loginSubtitle: 'Вашият AI асистент за правни изследвания',
  continueWithGoogle: 'Продължи с Google',
  continueWithMicrosoft: 'Продължи с Microsoft',
  continueWithWeChat: 'Продължи с WeChat',
  orContinueWith: 'или продължи с',
  emailTab: 'Имейл',
  phoneTab: 'Телефон',
  emailPlaceholder: 'Въведете вашия имейл',
  phonePlaceholder: 'Въведете телефонен номер',
  codePlaceholder: 'Въведете 6-цифрен код',
  sending: 'Изпращане...',
  verifying: 'Проверка...',
  verify: 'Потвърди',
  sendMagicLink: 'Изпрати магическа връзка',
  getVerificationCode: 'Получи код',
  resendCode: 'Изпрати повторно',
  resendIn: 'Изпрати отново след',
  magicLinkSent: 'Магическа връзка е изпратена на вашия имейл',
  magicLinkHint: 'Ще изпратим защитена връзка на вашия имейл',
  otpSent: 'Кодът за потвърждение е изпратен',
  agreeToTerms: 'Като продължавате, вие се съгласявате с нашите',
  privacyPolicy: 'Политика за поверителност',
  termsOfService: 'Условия за ползване',
  and: 'и',
  privacyTitle: 'Вашата поверителност е важна',
  privacyIntro: 'Използваме бисквитки и подобни технологии, за да ви предоставим най-доброто изживяване.',
  essentialCookies: 'Основни бисквитки',
  essentialDesc: 'Необходими за работата на сайта',
  analyticsCookies: 'Аналитични бисквитки',
  analyticsDesc: 'Помагат ни да подобрим услугата',
  marketingCookies: 'Маркетингови бисквитки',
  marketingDesc: 'Използват се за персонализирано съдържание',
  acceptAll: 'Приеми всички',
  essentialOnly: 'Само основни',
  customize: 'Персонализирай',
  savePreferences: 'Запази настройките',
  back: 'Назад',
  readPrivacyPolicy: 'Прочетете нашата политика за поверителност',
  cookiePolicy: 'Политика за бисквитките',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI преглед',
  aiDraft: 'AI чернова',
  smartAssistant: 'Шаблон',

  // 知识库搜索
  enableKnowledgeSearch: 'Активиране на търсене',
  knowledgeSearchDesc: 'AI търси във вашите документи',
  clickToDisable: 'Деактивиране',
  clickToEnable: 'Активиране',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Затвори панел с ресурси',
  uploading: 'Качване на %{fileName}...',
  processing: 'Обработка на %{fileName}...',
  uploadSuccess: '✓ %{fileName} качен',
  uploadError: '✗ Неуспешно качване: %{error}',
  quickAnswer: 'Бърз отговор',
  quickAnswerDesc: 'Бърз отговор на прости въпроси',
  cancelRequest: 'Отказ',
  library: 'Библиотека',
  filterAll: 'Всички',
  filterChat: 'Чатове',
  filterReview: 'Преглед',
  filterDraft: 'Чернова',
  filterTemplate: 'Шаблон',
  filterForm: 'Формуляр',
  thinking: 'Мисля...',
  thinkingProcess: 'Мисловен процес',
  analyzingLegalLogic: 'Анализ на правна логика...',
  lawhelperThinking: 'Lawhelper мисли...',
  serviceError: 'Грешка в услугата',
  uploaded: 'Качено',
  settingsGeneral: 'Общи',
  settingsNotifications: 'Известия',
  settingsAppearance: 'Външен вид',
  settingsProfile: 'Профил',
  settingsResponseNotifications: 'Известия за отговори',
  settingsResponseNotificationsDesc: 'Известие при завършване на AI отговор',
  settingsColorMode: 'Цветен режим',
  settingsLight: 'Светъл',
  settingsDark: 'Тъмен',
  settingsSystem: 'Системен',
  about: 'Относно',
  reviewTitle: 'Преглед на документ',
  exitReview: 'Изход от преглед',
  uploadPrompt: 'Качете PDF за преглед',
  uploadButton: 'Избор на файл',
  startChatConfig: 'Напишете "Прегледай този документ"',
  reviewPlaceholder: 'Въведете съобщение...',
  analyzing: 'Преглеждане...',
  reviewComplete: 'Прегледът завърши',
  issuesFound: 'Намерени %{count} проблема',
  draftTitle: 'Изготвяне на правен документ',
  draftPlaceholder: 'Редактирайте тук или поискайте от AI...',
  analyzingTemplate: 'Анализ на шаблон %{name}...',
  templateAnalyzed: '✅ Шаблон %{name} анализиран!',
  templateAnalysisPrompt: 'Анализ на ключови клаузи',
  parsingFailed: '⚠️ Неуспешен анализ на файла.',
  generating: 'Генериране...',
  generatedSuccess: '✅ Документът е генериран!',
  drafterWelcome: 'Добре дошли в AI асистент за документи',
  drafterYouCan: 'Можете:',
  drafterUploadTemplate: 'Да качите шаблон за AI анализ',
  drafterDescribeNeeds: 'Да опишете изискванията',
  drafterLetAiHelp: 'AI помага с договори, споразумения и др.',
  drafterExamples: 'Примери:',
  drafterExampleRental: '"Изгответе договор за наем"',
  drafterExampleLabor: '"Попълнете трудов договор"',
  drafterInputPlaceholder: 'Опишете нуждите си...',
  drafterThinking: 'Мисля...',
  drafterHistoryTitle: 'История',
  drafterNoHistory: 'Няма история',
  drafterNewChat: 'Нов чат',
  drafterHistory: 'История',
  drafterRemoveAttachment: 'Премахни прикачен файл',
  drafterLineHeight: 'Височина на ред',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Експорт като Word (.docx)',
  drafterExportPdf: 'Експорт като PDF',
  drafterSave: 'Запази документ',
  drafterDownload: 'Изтегли документ',
  drafterUndo: 'Отмени',
  drafterRedo: 'Повтори',
  drafterBold: 'Удебелен',
  drafterItalic: 'Курсив',
  drafterStrike: 'Зачеркнат',
  drafterUnderline: 'Подчертан',
  drafterHighlight: 'Маркиране',
  drafterLink: 'Вмъкни връзка',
  drafterAlignLeft: 'Ляво',
  drafterAlignCenter: 'Център',
  drafterAlignRight: 'Дясно',
  drafterAlignJustify: 'Двустранно',
  drafterList: 'Списък',
  drafterBulletList: 'Маркиран списък',
  drafterOrderedList: 'Номериран списък',
  drafterTaskList: 'Списък задачи',
  drafterOpenResource: 'Отвори ресурси',
  drafterStopGeneration: 'Спри генерирането',
  drafterAgentMode: 'Агент режим активен',
  drafterAgentModeOn: 'Агент режим активен',
  drafterAgentModeOff: 'Нормален режим',
  drafterUploadAttachment: 'Качи прикачен файл',
  drafterExit: 'Изход',
  drafterConfirm: 'Потвърди',
  drafterOpenLink: 'Отвори връзка',
  drafterDeleteLink: 'Изтрий връзка',
  drafterQuote: 'Цитат',
  workflowTitle: 'AI работен процес',
  workflowRunning: 'Изпълнение...',
  workflowReady: 'Готов',
  workflowCompleted: 'Завършен',
  workflowStartFailed: 'Неуспешен старт',
  workflowExecutionFailed: 'Неуспешно изпълнение',
  workflowInterrupted: 'Процесът е прекъснат',
  workflowProcessing: 'Обработка...',
  workflowStepsCompleted: 'стъпки завършени',
  workflowStepsTotal: 'Процес завършен (%{count} стъпки)',
  acceptChanges: 'Приеми промените',
  rejectChanges: 'Отхвърли промените',
  changesAccepted: 'Промените са приети',
  changesRejected: 'Промените са отхвърлени',
  stopWorkflow: 'Спри',
  restartWorkflow: 'Рестарт',
  startDrafting: 'Започни изготвяне',
  interrupt: 'Спри',
  documentSubject: 'Тема на документа *',
  documentType: 'Тип документ',
  jurisdiction: 'Юрисдикция',
  specialRequirements: 'Специални изисквания (по избор)',
  clickStartDrafting: 'Натиснете "Започни изготвяне"',
  docTypeContract: 'Договор',
  docTypeAgreement: 'Споразумение',
  docTypeNotice: 'Известие',
  docTypeLetter: 'Писмо',
  docTypePetition: 'Петиция',
  docTypeWill: 'Завещание',
  docTypePowerOfAttorney: 'Пълномощно',
  countryChina: 'Китай',
  countryUSA: 'САЩ',
  countryGermany: 'Германия',
  countryJapan: 'Япония',
  countryFrance: 'Франция',
  countryUK: 'Великобритания',
  citationVerified: 'Потвърдено',
  citationUnverified: 'Непотвърдено',
  imageLoadFailed: 'Неуспешно зареждане на изображение',
  smartDocTitle: 'Интелигентен асистент',
  smartDocChatTitle: 'AI асистент за документи',
  smartDocDropPrompt: 'Пуснете PDF тук',
  smartDocSelectFile: 'Избор на файл',
  smartDocOr: 'или',
  smartDocWelcomeTitle: 'Добре дошли в AI асистента',
  smartDocWelcomeYouCan: 'Можете:',
  smartDocUploadForAI: 'Да качите шаблон',
  smartDocDescribeDoc: 'Да опишете изисквания',
  smartDocLetAIDraft: 'AI помага с договори',
  smartDocExamples: 'Примери:',
  smartDocExampleRental: '"Изгответе договор за наем"',
  smartDocExampleLabor: '"Попълнете трудов договор"',
  smartDocInputPlaceholder: 'Опишете нуждите...',
  smartDocRemoveAttachment: 'Премахни файл',
  smartDocOpenResources: 'Отвори ресурси',
  smartDocExit: 'Изход',
  reviewStartFailed: 'Неуспешен старт на преглед',
  reviewFailed: 'Прегледът е неуспешен',
  reviewFoundIssues: 'Прегледът завърши, %{count} проблема.',
  cannotReadStream: 'Не може да се прочете потока',
  parseEventFailed: 'Неуспешен анализ на събитие',
  errorPrefix: 'Грешка',
  unknownError: 'Неизвестна грешка',
  file: 'Файл',
  loading: 'Зареждане...',
  localFolders: 'Локални папки',
  selectLocalFolder: 'Избор на локална папка',
  reselectFolder: 'Смяна на папка',
  addToContext: 'Добави в чата',
  saveFile: 'Запази',
  renameFile: 'Преименувай',
  fileSaved: 'Файлът е запазен',
  fileRenamed: 'Файлът е преименуван на %{name}',
  browserNotSupported: 'Браузърът не поддържа достъп до папки',
  noFolderSelected: 'Изберете локална папка',
  scanningFolder: 'Сканиране на папка...',
  selectFileToPreview: 'Изберете файл за преглед',
  aiAnalyze: 'AI анализ',
};
